import { Navigate } from "react-router-dom";
import { paths } from "./paths";

//Layouts
import FullLayout from "../layouts/FullLayout";

import TransactionsPage from "../pages/members/transactions/Transactions";

const WebRoutes = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      // { path: '/', index: true, element: <Navigate to={paths.dashboard} />},
      {
        path: "/",
        index: true,
        element: <Navigate to={paths.transactions} />,
      },
      { path: paths.transactions, exact: true, element: <TransactionsPage /> },
    ],
  },
];

export default WebRoutes;
